import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('product-detail-page-handler', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./product-detail-page-handler')
        ),
);
